var map = {
	"./address_image.svg": 161,
	"./animated_ashutosh.png": 162,
	"./animated_logo.svg": 163,
	"./blogs_image.svg": 164,
	"./cloud_infrastructure.svg": 165,
	"./codeInLogo.png": 166,
	"./contactMail.png": 167,
	"./coursera_logo.png": 168,
	"./data_science.svg": 169,
	"./deeplearning_ai_logo.png": 170,
	"./delhivery_logo.png": 171,
	"./developerActivity.svg": 172,
	"./dsc_logo.png": 173,
	"./education.svg": 174,
	"./experience.svg": 175,
	"./feelingProud.svg": 176,
	"./freecopy_logo.png": 177,
	"./fullstack.svg": 178,
	"./gcp_logo.png": 179,
	"./github_logo.png": 180,
	"./googleAssistant.jpg": 181,
	"./googleAssistant.svg": 182,
	"./google_logo.png": 183,
	"./ibm_logo.png": 184,
	"./iiitk_logo.png": 185,
	"./intel_logo.jpg": 186,
	"./iu_logo.png": 187,
	"./jsFramework.svg": 188,
	"./kutumb_logo.png": 189,
	"./legato_logo.png": 190,
	"./manOnTable.svg": 191,
	"./microsoft_logo.png": 192,
	"./mozilla_logo.png": 193,
	"./muffito_logo.png": 194,
	"./nextuLogo.jpg": 195,
	"./nptel_logo.png": 196,
	"./nu_logo.png": 197,
	"./portfolio.gif": 198,
	"./programmer.svg": 199,
	"./projects_image.svg": 200,
	"./pwa.png": 201,
	"./saayaHealthLogo.png": 202,
	"./shyam_image.png": 203,
	"./stanford_logo.png": 204,
	"./talksCardBack.svg": 205,
	"./talksCardBackAlt.svg": 206,
	"./tiktok_logo.png": 207,
	"./ui_ux_design.svg": 208,
	"./vit_logo.png": 209,
	"./wipro_logo.png": 210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;